import { css } from '@emotion/core'
import { Bleed } from '@fs/zion-ui'
import React, { type ReactNode } from 'react'

const tabsRowCss = css`
  display: flex;
  overflow: hidden;
  background: var(--gray00a);
`

const tabCss = css`
  background: var(--gray00a);
  color: var(--gray100);
  cursor: default;
  flex-shrink: 0;
  height: 48px;
  line-height: 48px;
  min-width: 90px;
  max-width: 360px;
  padding: 0 16px;
  text-align: center;
  font-size: var(--text-size-b);
  white-space: nowrap;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;

  &:first-of-type {
    margin-inline-start: auto;
    padding-inline-start: var(--bleedable-start, 16px);
  }

  &:last-of-type {
    margin-inline-end: auto;
    padding-inline-end: var(--bleedable-end, 16px);
  }
`

export type TabItem = {
  key: string
  content: ReactNode
}

export function TabsSkeleton({ tabs }: { tabs: TabItem[] }): JSX.Element {
  return (
    <Bleed sides>
      <div css={tabsRowCss} aria-hidden="true">
        {tabs.map(({ key, content }) => (
          <div key={key} css={tabCss}>
            {content}
          </div>
        ))}
      </div>
    </Bleed>
  )
}
